import MostRecentMemeContainerElement from "./mostRecentMemeContainerElement.js";
import "./mostRecentMemes.css";

const MostRecentMemesLogic = ({
    isLoading,
    mostRecentMemes,
    currentImageDisplay,
    setCurrentImageDisplay,
    deleteMostRecentMeme,
}) => {
    const displayMostRecentmemes = () => {
        if (!isLoading) {
            return (
                <MostRecentMemeContainerElement
                    currentImageDisplay={currentImageDisplay}
                    setCurrentImageDisplay={setCurrentImageDisplay}
                    mostRecentMemes={mostRecentMemes}
                    deleteMostRecentMeme={deleteMostRecentMeme}
                />
            );
        }
    };

    return (
        <div className="MostRecentMemeContainer">
            {displayMostRecentmemes()}
        </div>
    );
};

export default MostRecentMemesLogic;
